import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="nn-footer">
      <div className="nn-footer-inner">
        <div className="nn-footer-left">
          <div className="nn-footer-co">
            &copy; 2026 NeXus NeuroInformatics, Inc. &middot; Delaware C-Corporation
          </div>
          <div className="nn-footer-parent">
            An operating subsidiary of{' '}
            <a href="https://nexusconcordat.com">Nexus Concordat, Inc.</a>
          </div>
        </div>
        <div className="nn-footer-right">
          Patents Pending: 63/939,190 &middot; 63/962,385 &middot; 63/988,485 &middot; 64/034,536
        </div>
      </div>
    </footer>
  );
}

export default Footer;
